import React from 'react'
import styles from './styles.module.scss'
import SvgPhone from '@/src/assets/svgs/collection/phone-call.svg'
import SvgLocation from '@/src/assets/svgs/collection/location.svg'
import Merchant from '@/src/interfaces/merchant/merchant'
import Link from 'next/link'
import MapOsm from '@/src/components/misc/map-osm/map-osm'
import { useMerchant } from '@/src/context/merchant/merchant-context'

interface Props {
    address: Merchant.Address
}

export default function LocationCard({ address }: Props) {
    const { merchantSummary, merchantDetailed } = useMerchant()

    if (address === undefined || address.latitude === 0 && address.longitude === 0)
        return <></>

    const getGoogleMapsUrl = () => {
        const formattedAddress = encodeURIComponent(
            `${address.street}, ${address.number} - ${address.district}, ${address.city} - ${address.state}`
        )
        return `https://www.google.com/maps/search/?api=1&query=${formattedAddress}`
    }

    return (
        <div className={styles.container}>
            <h2 className={`${styles.title} font-lg`}>{merchantDetailed?.model?.showAddress ? 'Localização' : 'Telefone'}</h2>
            {
                merchantDetailed?.model?.showAddress &&
                <>
                    <div className={styles.mapArea}>
                        <MapOsm className={styles.map} lat={address.latitude} lng={address.longitude} />
                    </div>
                    <Link
                        href={getGoogleMapsUrl()}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.address}
                    >
                        <SvgLocation className={styles.locationMapPinSvg} />
                        <p>{address.street}, {address.number} - {address.district}, {address.city} - {address.state}</p>
                    </Link>
                </>
            }
            {
                merchantSummary?.phone &&
                <Link href={`tel:${merchantSummary.phone.formatToPhoneNumber()}`} className={styles.callArea}>
                    <div className={styles.contact}>
                        <SvgPhone className={styles.calendarSvg} />
                        <p>{merchantSummary.phone.formatToPhoneNumber()}</p>
                    </div>
                </Link>
            }
        </div>
    )
}
